export default __webpack_public_path__ + "static/media/Mark-2-HUD-05.99a8b224.jpg";